import React from 'react';
import { ISvgIconProps, SvgIcon } from './svg-icon.component';

export const MinusCircleIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1} fill={"none"} {...props} viewBox="0 0 20 20" ratio={1}>
            <path
                d="M19 10.0005C19 5.03174 14.9688 1.00049 10 1.00049C5.03125 1.00049 1 5.03174 1 10.0005C1 14.9692 5.03125 19.0005 10 19.0005C14.9688 19.0005 19 14.9692 19 10.0005Z"
                stroke={props.color? props.color: "currentColor"} strokeWidth="1.5" strokeMiterlimit="10"/>
            <path d="M13.75 9.99707H6.25" stroke={props.color? props.color: "currentColor"} strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </SvgIcon>
    )
}
